// Примечание переводчику: Сохраняйте деловой нейтральный стиль, женский род для артиста, не переводите отраслевые термины
// (GoGo, Crazy menu и т.п.), а также плейсхолдеры вида {count} и текст в кавычках — от них зависят интерфейс и форматирование.
export const form = {
  email: {
    label: 'Email',
    placeholder: 'Введите адрес почты'
  },
  name: {
    label: 'Имя',
    placeholder: 'Введите имя'
  },

  clubName: {
    label: 'Название клуба',
    placeholder: 'Введите название клуба',
    description: 'Введите название латиницей'
  },
  address: {
    label: 'Адрес',
    placeholder: 'Введите адрес'
  },
  workPeriod: {
    start: {
      placeholder: 'Начало работы'
    },
    end: {
      placeholder: 'Конец работы'
    }
  },
  workTime: {
    start: {
      label: 'Время открытия'
    },
    end: {
      label: 'Время закрытия'
    }
  },
  country: {
    label: 'Укажите расположение клуба',
    placeholder: 'Укажите расположение клуба'
  },
  role: {
    label: 'Вакансии в клубе'
  },
  currency: {
    label: 'Укажите валюту выплат артистам',
    placeholder: 'Укажите валюту выплат артистам'
  },
  nativeLanguage: {
    label: 'Родной язык',
    placeholder: 'Укажите родной язык'
  },

  lastName: {
    label: 'Фамилия',
    placeholder: 'Введите фамилию'
  },
  birth: {
    label: 'Дата рождения',
    placeholder: 'Введите дату рождения'
  },
  password: {
    label: 'Пароль',
    placeholder: 'Введите пароль',
    description:
      'Пароль должен содержать минимум 8 символов верхнего и нижнего регистра, цифры и специальные символы (например, !, @, #, $)'
  },
  resetPassword: {
    new: {
      label: 'Новый пароль',
      placeholder: 'Введите новый пароль'
    },
    confirm: {
      label: 'Подтвердите пароль',
      placeholder: 'Введите новый пароль'
    }
  },
  penalties: {
    placeholder: 'Введите название штрафа'
  },
  phone: {
    label: 'Номер телефона',
    placeholder: '+373-000-00-00'
  },
  buttons: {
    continue: 'Продолжить',
    login: 'Вход',
    send: 'Отправить',
    cancel: 'Отменить',
    confirm: 'Подтвердить',
    resend: 'Отослать повторно',
    register: 'Зарегистрироваться',
    registerRequest: 'Оставить заявку для регистрации'
  },
  links: {
    forgotPasswordLink: 'Забыли пароль?',
    login: 'Войти',
    haveAccount: 'У меня уже есть аккаунт',
    privacy: 'Пользовательского соглашения и Политикой конфиденциальности.'
  },
  other: {
    or: 'Или'
  },
  approximateStartDate: { label: 'Примерная дата начала работы' },
  approximateEndDate: { label: 'Примерная дата конца работы' },
  search: {
    placeholder: 'Поиск',
    placeholderCitizienship: 'Поиск по гражданству'
  },
  positionItem: {
    label: 'Введите позицию'
  },

  paymentFrequency: {
    label: 'Частота выплат'
  },
  price: {
    label: 'Цена'
  },
  priceForArtist: {
    label: 'Сумма артистке'
  },
  artistPercent: {
    label: 'Процент артистке'
  }
};
